(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Spy"] = factory();
	else
		root["Spy"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "/7QA");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/7QA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Spy; });
/* harmony import */ var object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("MgzW");
/* harmony import */ var object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(object_assign__WEBPACK_IMPORTED_MODULE_0__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var domain = location.protocol === 'http:' ? 'http://sestat.baidu.com/mwb2.gif?' : 'https://sp1.baidu.com/5b1ZeDe5KgQFm2e88IuM_a/mwb2.gif?';
var isIos = /(iPhone|iPod|iPad)/.test(navigator.userAgent);

function err(msg) {
  console.error("[spy_log]".concat(msg));
}

function stringify(obj) {
  return Object.keys(obj).map(function (key) {
    var value = obj[key];

    if (typeof value === 'undefined') {
      value = '';
    } else if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }

    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }).join('&');
}

var Spy = function () {
  function Spy(option) {
    _classCallCheck(this, Spy);

    this.sample = {};
    this.markCache = {};
    this.listenErrorOption = {};
    this.globalErrorCallback = this.globalErrorCallback.bind(this);

    if (!option.pid) {
      throw new Error('pid is required');
    }

    this.option = {
      pid: option.pid,
      lid: option.lid,
      check: option.check !== false,
      sample: option.sample
    };
  }

  _createClass(Spy, [{
    key: "send",
    value: function send(query) {
      if (!this.check(query)) {
        return;
      }

      if (typeof query.sample === 'number') {
        if (Math.random() > query.sample) {
          return;
        }
      } else if (typeof this.option.sample === 'number' && Math.random() > this.option.sample) {
        return;
      }

      delete query.sample;
      query = object_assign__WEBPACK_IMPORTED_MODULE_0___default()({
        pid: this.option.pid,
        lid: this.option.lid,
        ts: Date.now(),
        group: 'common'
      }, query);
      var url = domain + stringify(query);

      if (!(!isIos && navigator.sendBeacon && navigator.sendBeacon(url))) {
        new Image().src = url;
      }
    }
  }, {
    key: "check",
    value: function check(query) {
      if (!this.option.check) {
        return true;
      }

      var types = ['perf', 'except', 'dist', 'count'];

      if (types.indexOf(query.type) === -1) {
        err('type only is one of ' + types.join(', '));
        return false;
      }

      if (query.group && query.group.length > 30) {
        err('group length execeeds 30');
        return false;
      }

      var simpleReg = /^[a-zA-Z0-9-_]{0,30}$/;

      if (query.type === 'except') {
        if (!(typeof query.info.msg === 'string' && query.info.msg.length)) {
          err('info msg field must be not empty and is String');
          return false;
        }
      } else {
        for (var _i = 0, _Object$keys = Object.keys(query.info); _i < _Object$keys.length; _i++) {
          var infoKey = _Object$keys[_i];

          if (!simpleReg.test(infoKey)) {
            err("info key [".concat(infoKey, "] is unexpected. ") + 'Length must be not more than 30. ' + 'Supported chars: a-zA-Z0-9-_');
            return false;
          }

          var infoVal = query.info[infoKey];

          if (query.type === 'dist') {
            if (infoVal.length > 30) {
              err("info.".concat(infoKey, " value length execeeds 30 when type == 'dist'"));
              return false;
            }
          } else if (typeof infoVal !== 'number') {
            err("info.".concat(infoKey, " value must be number"));
            return false;
          }
        }
      }

      if (query.dim) {
        for (var _i2 = 0, _Object$keys2 = Object.keys(query.dim); _i2 < _Object$keys2.length; _i2++) {
          var dimKey = _Object$keys2[_i2];

          if (!simpleReg.test(dimKey)) {
            err("dim key [".concat(dimKey, "] is unexpected. ") + 'Length must be not more than 30. ' + 'Supported chars: a-zA-Z0-9-_');
            return false;
          }

          var dimVal = query.dim[dimKey];

          if (!/^[a-zA-Z0-9\-_\*\.\s\/#\+@\&\u4e00-\u9fa5]{0,30}$/.test(dimVal)) {
            err("dim.".concat(dimKey, " value [").concat(dimVal, "] is unexpected. ") + 'Length must be not more than 30. ' + 'Supported chars: a-zA-Z0-9-_*. /#+@& and Chinese');
            return false;
          }
        }
      }

      return true;
    }
  }, {
    key: "sendPerf",
    value: function sendPerf(option) {
      this.send(object_assign__WEBPACK_IMPORTED_MODULE_0___default()({
        type: 'perf'
      }, option));
    }
  }, {
    key: "sendExcept",
    value: function sendExcept(option) {
      this.send(object_assign__WEBPACK_IMPORTED_MODULE_0___default()({
        type: 'except'
      }, option));
    }
  }, {
    key: "sendDist",
    value: function sendDist(option) {
      this.send(object_assign__WEBPACK_IMPORTED_MODULE_0___default()({
        type: 'dist'
      }, option));
    }
  }, {
    key: "sendCount",
    value: function sendCount(option) {
      this.send(object_assign__WEBPACK_IMPORTED_MODULE_0___default()({
        type: 'count'
      }, option));
    }
  }, {
    key: "sendExceptForError",
    value: function sendExceptForError(e, option) {
      var newOpt = object_assign__WEBPACK_IMPORTED_MODULE_0___default()({}, option);

      newOpt.info = object_assign__WEBPACK_IMPORTED_MODULE_0___default()({}, option.info || {}, {
        msg: e.message,
        stack: e.stack
      });
      this.sendExcept(newOpt);
    }
  }, {
    key: "getPerformanceTimingInfo",
    value: function getPerformanceTimingInfo(cb) {
      if (window.performance && window.performance.timing) {
        var timing = window.performance.timing;

        var handle = function handle() {
          setTimeout(function () {
            if (timing.loadEventEnd && timing.loadEventEnd > 0) {
              var navigationStart = timing.navigationStart,
                  requestStart = timing.requestStart,
                  responseStart = timing.responseStart,
                  responseEnd = timing.responseEnd,
                  domContentLoadedEventStart = timing.domContentLoadedEventStart,
                  domComplete = timing.domComplete,
                  domLoading = timing.domLoading,
                  domainLookupStart = timing.domainLookupStart,
                  domainLookupEnd = timing.domainLookupEnd,
                  connectStart = timing.connectStart,
                  connectEnd = timing.connectEnd,
                  loadEventStart = timing.loadEventStart,
                  loadEventEnd = timing.loadEventEnd;
              cb({
                dns: domainLookupEnd - domainLookupStart,
                tcp: connectEnd - connectStart,
                req: responseStart - requestStart,
                res: responseEnd - responseStart,
                dct: domComplete - domLoading,
                load: loadEventEnd - loadEventStart,
                domready: domContentLoadedEventStart - navigationStart,
                finish: loadEventEnd - navigationStart
              });
            } else {
              handle();
            }
          }, 200);
          window.removeEventListener('load', handle);
        };

        if (timing.loadEventEnd && timing.loadEventEnd > 0) {
          handle();
        } else {
          window.addEventListener('load', handle);
        }
      } else {
        cb();
      }
    }
  }, {
    key: "listenGlobalError",
    value: function listenGlobalError(option) {
      if (option) {
        this.listenErrorOption = option;
      }

      window.removeEventListener('error', this.globalErrorCallback);
      window.addEventListener('error', this.globalErrorCallback);
    }
  }, {
    key: "unListenGlobalError",
    value: function unListenGlobalError() {
      window.removeEventListener('error', this.globalErrorCallback);
      this.listenErrorOption = {};
    }
  }, {
    key: "startMark",
    value: function startMark(sign) {
      this.markCache[sign] = {
        start: Date.now()
      };
    }
  }, {
    key: "endMark",
    value: function endMark(sign) {
      if (this.markCache[sign]) {
        this.markCache[sign].total = Date.now() - this.markCache[sign].start;
        return this.markCache[sign].total;
      }

      return null;
    }
  }, {
    key: "clearMark",
    value: function clearMark(sign) {
      if (this.markCache[sign]) {
        delete this.markCache[sign];
      }
    }
  }, {
    key: "getAllMark",
    value: function getAllMark() {
      var ret = {};

      for (var _i3 = 0, _Object$keys3 = Object.keys(this.markCache); _i3 < _Object$keys3.length; _i3++) {
        var sign = _Object$keys3[_i3];
        ret[sign] = this.markCache[sign].total;
      }

      return ret;
    }
  }, {
    key: "clearAllMark",
    value: function clearAllMark() {
      this.markCache = {};
    }
  }, {
    key: "globalErrorCallback",
    value: function globalErrorCallback(event) {
      var eventError = event.error || {};

      var newOpt = object_assign__WEBPACK_IMPORTED_MODULE_0___default()({}, this.listenErrorOption);

      newOpt.info = object_assign__WEBPACK_IMPORTED_MODULE_0___default()({}, this.listenErrorOption.info || {}, {
        msg: event.message,
        colno: event.colno || event.column || window.event && window.event.errorCharacter,
        lineno: event.lineno || event.line,
        filename: event.filename || event.sourceURL,
        stack: eventError.stack
      });
      this.sendExcept(newOpt);
    }
  }]);

  return Spy;
}();



/***/ }),

/***/ "MgzW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ })

/******/ })["default"];
});